import React from 'react';

// The company time zone picker, in Settings > Company and on the Getting
// started card. The options come from the server (GET /api/company
// timezone_options, GET /api/dashboard/onboarding timezoneOptions): the same
// list companies_timezone_check is built from, so the select cannot offer a
// zone the database would refuse.
function TimezoneSelect({ id, name = 'timezone', value, options, onChange, disabled = false }) {
  const list = Array.isArray(options) ? options : [];
  // A stored zone missing from the list (not possible under the CHECK, but
  // cheap to guard) still shows, so the select never claims a different zone.
  const known = list.some((z) => z.value === value);
  return (
    <select
      id={id}
      name={name}
      className="form-input"
      value={value || ''}
      onChange={onChange}
      disabled={disabled || list.length === 0}
    >
      {!known && value && <option value={value}>{value}</option>}
      {list.map((z) => (
        <option key={z.value} value={z.value}>{z.label}</option>
      ))}
    </select>
  );
}

export default TimezoneSelect;
